<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-school
            </v-icon>
            <span class="title"><b>Detail Data Beasiswa</b></span>
            <v-spacer></v-spacer>
            <v-btn
              :to="{ name: 'SuratAdmin' }"
              color="error"
              icon
              x-small>
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <alertsp :alertdata="alertgetdata"></alertsp>
              <div class="text-center" v-if="loading.getdata">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </div>
              <v-row justify="center" v-if="detaildata">
                <v-col cols="12" md="8" class="px-md-10">
                  <v-row class="black--text">
                    <v-col cols="12" md="12">
                      <div class="title font-weight-bold text-decoration-underline">
                        Data Berkas
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-tabs
                        v-model="tabberkas"
                        show-arrows>
                        <v-tab href="#tab-spdir" class="text-capitalize">
                          Permohonan direktur
                        </v-tab>
                        <v-tab href="#tab-prestasi" class="text-capitalize">
                          Bukti prestasi
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items :touchless="true" v-model="tabberkas">
                        <v-tab-item value="tab-spdir">
                          <v-card flat>
                            <v-card-text>
                              <div>
                                <object
                                  :data="detaildata.urlspdir"
                                  type="application/pdf"
                                  class="pdf-embed-custom">
                                  <p>
                                    Web browser anda tidak memiliki PDF plugin.<br>
                                    Sebaliknya anda dapat download berkaspada tautan berikut:<br>
                                    <a target="_blank" :href="detaildata.urlspdir">
                                      Download
                                    </a>
                                  </p>
                                </object>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                        <v-tab-item value="tab-prestasi">
                          <v-card flat>
                            <v-card-text>
                              <div>
                                <object
                                  :data="detaildata.urlprestasi"
                                  type="application/pdf"
                                  class="pdf-embed-custom">
                                  <p>
                                    Web browser anda tidak memiliki PDF plugin.<br>
                                    Sebaliknya anda dapat download berkaspada tautan berikut:<br>
                                    <a target="_blank" :href="detaildata.urlprestasi">
                                      Download
                                    </a>
                                  </p>
                                </object>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4" class="pl-md-10">
                  <div class="text-right">
                    <v-chip
                      color="red"
                      fab
                      text-color="white">
                      <v-icon left>bookmark</v-icon>
                      {{ detaildata.status_bs }}
                    </v-chip>
                  </div>
                  <v-row class="black--text">
                    <v-col cols="12" md="12">
                      <div class="title font-weight-bold text-decoration-underline">
                        Data Profile
                      </div>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Periode</span>
                      <h2 class="subtitle-1 font-weight-bold">
                        {{ detaildata.period_bs }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Beasiswa</span>
                      <h2 class="subtitle-1 font-weight-bold">
                        {{ detaildata.nama_jb ? detaildata.nama_jb : '-'  }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Status pengajuna</span>
                      <h2 class="subtitle-1 font-weight-bold">
                        {{ detaildata.status_bs }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Tanggal pengajuan</span>
                      <h2 class="subtitle-1 font-weight-bold">
                        {{ detaildata.tgl_bs }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">NIM</span>
                      <h2 class="subtitle-1 font-weight-bold">
                        {{ detaildata.user_bs }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Nama</span>
                      <h2 class="subtitle-1 font-weight-bold">
                        {{ detaildata.p_nama }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">Prodi</span>
                      <h2 class="subtitle-1 font-weight-bold">
                        {{ detaildata.p_jenjang }} {{ detaildata.p_prodi }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <span class="text-subtitle-1">IPK</span>
                      <h2 class="subtitle-1 font-weight-bold">
                        {{ detaildata.p_ipk }}
                      </h2>
                    </v-col>
                    <v-col cols="12" md="12">
                      <div class="title font-weight-bold text-decoration-underline">
                        Data Penilaian
                      </div>
                    </v-col>
                  </v-row>
                  <v-form
                    ref="formupdatesurat"
                    v-model="formadd.valid"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="!canchange"
                          v-model="updatesurat.n_akademik"
                          label="Nilai akademik"
                          :rules="[rules.required, rules.max100]"
                          name="n_akademik"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="!canchange"
                          v-model="updatesurat.n_wawancara"
                          label="Nilai wawancara"
                          :rules="[rules.required, rules.max100]"
                          name="n_wawancara"
                          required>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="!canchange"
                          v-model="updatesurat.n_prestasi"
                          label="Nilai prestasi"
                          :rules="[rules.required, rules.max100]"
                          name="n_prestasi"
                          required>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <alertsp :alertdata="alertdata"></alertsp>
                        <div class="text-center" v-if="loading.update">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-btn
                          v-if="!loading.update && canchange"
                          large
                          block
                          :disabled="!formadd.valid"
                          color="success"
                          class="mr-4 mt-5"
                          @click="submitUpdate">
                          Simpan
                        </v-btn>
                        <v-btn
                          v-if="!canchange"
                          outlined
                          large
                          block
                          color="primary"
                          class="mr-4 mt-5"
                          :to="{ name: 'SuratAdmin' }">
                          Kembali
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getDateTodayId } from '../../utils/dateFormatCustom.js';
import { mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'SuratDetailAdmin',
  props: ['kodesurat'],
  data: () => ({
    alertgetdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      update: false,
      printsurat: false,
    },
    prefix: process.env.VUE_APP_PREFIX,
    api: process.env.VUE_APP_API,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    baseurl: process.env.VUE_APP_BASEURL,
    liststatus: ['permohonan', 'siap', 'tolak'],
    listttd: [],
    detaildata: null,
    updatesurat: {
      id_bs: '',
      p_nama: '',
      n_akademik: '',
      n_wawancara: '',
      n_prestasi: '',
    },
    formadd: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      max100: (v) => v >= 0 && v <= 100 || 'Range 0-100',
      minpass: (v) => (v) && v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    canchange: true,
    tabberkas: 'tab-spdir',
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'usernik',
      'staticdata',
    ]),
  },
  mounted() {
    if (this.kodesurat) {
      this.getDetailSurat();
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    dateToIndo(value) {
      return getDateTodayId(value);
    },
    kelaminParse(value) {
      return value === 'L' ? 'Laki-Laki' : 'Perempuan';
    },
  },
  methods: {
    printSurat() {
      if (this.tokenscr && this.detaildata.kode_surat && this.detaildata.nik_surat) {
        this.loading.printsurat = true;
        this.axios
          .get(
            this.api + '/api/surat/printsurat/' + this.detaildata.kode_surat + '/' + this.detaildata.nik_surat,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
              responseType: 'blob',
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.detaildata.kode_surat + '.doc');
              document.body.appendChild(link);
              link.click();
            }
            this.loading.printsurat = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.printsurat = false;
          });
      }
    },
    getTandatangan() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/setting/',
            {
              params: {
                slug: 'tandatangan',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listttd = resdata.data;
                this.updatesurat.ttd_surat = this.updatesurat.ttd_surat ? this.updatesurat.ttd_surat : this.listttd[0];
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    checkCanChange() {
      this.canchange = true;
      const denystatus = ['siap', 'tolak'];
      if (denystatus.indexOf(this.updatesurat.status_skm) >= 0) {
        this.canchange = false;
      }
    },
    getDetailSurat() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/beasiswa/' + this.kodesurat,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.detaildata = resdata.data[0];
                  this.detaildata.urlspdir = this.api + '/upload/media/berkas/' + resdata.data[0].f_spdir;
                  this.detaildata.urlprestasi = this.api + '/upload/media/berkas/' + resdata.data[0].f_prestasi;
                  // old
                  this.updatesurat.id_bs = resdata.data[0].id_bs;
                  this.updatesurat.p_nama = resdata.data[0].p_nama;
                  this.updatesurat.n_akademik = resdata.data[0].n_akademik;
                  this.updatesurat.n_wawancara = resdata.data[0].n_wawancara;
                  this.updatesurat.	n_prestasi = resdata.data[0].	n_prestasi;
                  this.checkCanChange();
                  // this.getTandatangan();
                } else {
                  this.alertgetdata.show = true;
                  this.alertgetdata.type = 'error';
                  this.alertgetdata.text = 'Data tidak ditemukan!';
                }
              } else {
                this.alertgetdata.show = true;
                this.alertgetdata.type = 'error';
                this.alertgetdata.text = resdata.message;
              }
            } else {
              this.alertgetdata.show = true;
              this.alertgetdata.type = 'error';
              this.alertgetdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertgetdata.show = true;
            this.alertgetdata.type = 'error';
            this.alertgetdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      }
    },
    submitUpdate() {
      this.alertdata.show = false;
      if (this.$refs.formupdatesurat.validate()) {
        if (this.tokenscr) {
          console.log(this.updatesurat);
          this.loading.update = true;
          this.axios
            .put(
              this.api + '/api/beasiswa/',
              qs.stringify(
                this.updatesurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                console.log(resdata);
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Penilaian "' + this.updatesurat.p_nama + '" berhasil disimpan!';
                  this.getDetailSurat();
                  this.$root.$emit('app-getnotifiaction');
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.update = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.update = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    QrcodeVue,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-underline{
    text-decoration: underline;
  }
  .border-solid-thin{
    border: solid thin #f1f1f1;
  }
</style>
